import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

const api = axios.create({
  baseURL: API_URL
});

// Request interceptor - token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - 401 hatası yakala
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (credentials) => api.post('/auth/login', credentials);
export const getMe = () => api.get('/auth/me');
export const changePassword = (data) => api.put('/auth/change-password', data);

// Users
export const getUsers = () => api.get('/users');
export const getUser = (id) => api.get(`/users/${id}`);
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

// Departments
export const getDepartments = () => api.get('/departments');
export const getDepartment = (id) => api.get(`/departments/${id}`);
export const createDepartment = (data) => api.post('/departments', data);
export const updateDepartment = (id, data) => api.put(`/departments/${id}`, data);
export const deleteDepartment = (id) => api.delete(`/departments/${id}`);

// Device Categories
export const getDeviceCategories = () => api.get('/device-categories');
export const getDeviceCategory = (id) => api.get(`/device-categories/${id}`);
export const createDeviceCategory = (data) => api.post('/device-categories', data);
export const updateDeviceCategory = (id, data) => api.put(`/device-categories/${id}`, data);
export const deleteDeviceCategory = (id) => api.delete(`/device-categories/${id}`);

// Category Fields (Dinamik Alanlar)
export const getCategoryFields = (categoryId) => api.get(`/device-categories/${categoryId}/fields`);
export const addCategoryField = (categoryId, data) => api.post(`/device-categories/${categoryId}/fields`, data);
export const saveCategoryFields = (categoryId, fields) => api.post(`/device-categories/${categoryId}/fields/save`, { fields });
export const updateCategoryField = (fieldId, data) => api.put(`/device-categories/fields/${fieldId}`, data);
export const deleteCategoryField = (fieldId) => api.delete(`/device-categories/fields/${fieldId}`);

// Device Parts (Cihaz Parçaları)
export const getDeviceParts = (deviceId) => api.get(`/device-parts/device/${deviceId}`);
export const getDevicePartCosts = (deviceId) => api.get(`/device-parts/device/${deviceId}/costs`);
export const addDevicePart = (deviceId, data) => api.post(`/device-parts/device/${deviceId}`, data);
export const updateDevicePart = (partId, data) => api.put(`/device-parts/${partId}`, data);
export const recordPartMaintenance = (partId, data) => api.post(`/device-parts/${partId}/maintenance`, data);
export const replaceDevicePart = (partId, data) => api.post(`/device-parts/${partId}/replace`, data);
export const deleteDevicePart = (partId) => api.delete(`/device-parts/${partId}`);
export const getMaintenanceDueParts = (days) => api.get('/device-parts/maintenance-due', { params: { days } });

// Checklists
export const getChecklistTemplates = (params) => api.get('/checklists/templates', { params });
export const getChecklistTemplate = (id) => api.get(`/checklists/templates/${id}`);
export const createChecklistTemplate = (data) => api.post('/checklists/templates', data);
export const updateChecklistTemplate = (id, data) => api.put(`/checklists/templates/${id}`, data);
export const deleteChecklistTemplate = (id) => api.delete(`/checklists/templates/${id}`);

// Devices
export const getDevices = (params) => api.get('/devices', { params });
export const getDevice = (id) => api.get(`/devices/${id}`);
export const createDevice = (data) => api.post('/devices', data);
export const updateDevice = (id, data) => api.put(`/devices/${id}`, data);
export const deleteDevice = (id) => api.delete(`/devices/${id}`);
export const getDeviceStats = () => api.get('/devices/stats');
export const getOverdueDevices = () => api.get('/devices/overdue');
export const getDeviceChecklist = (id, type) => api.get(`/devices/${id}/checklist`, { params: { type } });
export const uploadDeviceDocument = (id, formData) => api.post(`/devices/${id}/documents`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteDeviceDocument = (deviceId, documentId) => api.delete(`/devices/${deviceId}/documents/${documentId}`);

// Maintenances
export const getMaintenances = (params) => api.get('/maintenances', { params });
export const getMaintenance = (id) => api.get(`/maintenances/${id}`);
export const createMaintenance = (data) => api.post('/maintenances', data);
export const startMaintenance = (id) => api.put(`/maintenances/${id}/start`);
export const completeMaintenance = (id, data) => api.put(`/maintenances/${id}/complete`, data);
export const cancelMaintenance = (id, data) => api.put(`/maintenances/${id}/cancel`, data);
export const getMaintenanceStats = () => api.get('/maintenances/stats');
export const getOverdueMaintenances = () => api.get('/maintenances/overdue');

// Maintenance Workflow - Planlama, Onay, Atama
export const getPendingApprovalMaintenances = (params) => api.get('/maintenances/pending-approval', { params });
export const approveMaintenance = (id, data) => api.put(`/maintenances/${id}/approve`, data);
export const rejectMaintenance = (id, data) => api.put(`/maintenances/${id}/reject`, data);
export const assignTechnicians = (id, data) => api.put(`/maintenances/${id}/assign`, data);
export const getMyMaintenanceAssignments = () => api.get('/maintenances/my-assignments');
export const respondToMaintenanceAssignment = (id, data) => api.put(`/maintenances/${id}/respond`, data);

// Maintenance Tasks and Materials
export const addMaintenanceTask = (id, data) => api.post(`/maintenances/${id}/tasks`, data);
export const addMaintenanceMaterial = (id, data) => api.post(`/maintenances/${id}/materials`, data);

// Public (auth gerektirmez)
export const getDeviceCard = (id) => api.get(`/public/devices/${id}/card`);

// Maintenance Documents
export const getMaintenanceDocuments = (id) => api.get(`/maintenances/${id}/documents`);
export const uploadMaintenanceDocuments = (id, formData) => api.post(`/maintenances/${id}/documents`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const downloadMaintenanceDocument = (id, documentId) => api.get(`/maintenances/${id}/documents/${documentId}/download`, {
  responseType: 'blob'
});
export const deleteMaintenanceDocument = (id, documentId) => api.delete(`/maintenances/${id}/documents/${documentId}`);
export const deleteMaintenance = (id) => api.delete(`/maintenances/${id}`);

// Periodic Controls
export const getPeriodicControls = (params) => api.get('/periodic-controls', { params });
export const getPeriodicControl = (id) => api.get(`/periodic-controls/${id}`);
export const createPeriodicControl = (data) => api.post('/periodic-controls', data);
export const startPeriodicControl = (id) => api.put(`/periodic-controls/${id}/start`);
export const completePeriodicControl = (id, formData) => api.put(`/periodic-controls/${id}/complete`, formData, {
  headers: formData instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {}
});
export const cancelPeriodicControl = (id, data) => api.put(`/periodic-controls/${id}/cancel`, data);
export const getPeriodicControlStats = () => api.get('/periodic-controls/stats');
export const uploadPeriodicControlReport = (id, formData) => api.post(`/periodic-controls/${id}/report`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const downloadPeriodicControlReport = (id) => api.get(`/periodic-controls/${id}/report/download`, { responseType: 'blob' });
export const previewPeriodicControlReport = (id) => api.get(`/periodic-controls/${id}/report/preview`, { responseType: 'blob' });
export const deletePeriodicControl = (id) => api.delete(`/periodic-controls/${id}`);

// Deletion Logs (sadece ogs)
export const getDeletionLogs = () => api.get('/deletion-logs');
export const getDeletionLogStats = () => api.get('/deletion-logs/stats');

// Fault Reports
export const getFaultReports = (params) => api.get('/fault-reports', { params });
export const getFaultReport = (id) => api.get(`/fault-reports/${id}`);
export const createFaultReport = (data) => api.post('/fault-reports', data);
export const updateFaultReport = (id, data) => api.put(`/fault-reports/${id}`, data);
export const updateFaultReportStatus = (id, data) => api.put(`/fault-reports/${id}/status`, data);
export const deleteFaultReport = (id) => api.delete(`/fault-reports/${id}`);
export const getFaultReportStats = () => api.get('/fault-reports/stats');
export const addFaultReportTask = (id, data) => api.post(`/fault-reports/${id}/tasks`, data);
export const addFaultReportMaterial = (id, data) => api.post(`/fault-reports/${id}/materials`, data);

// Device specific endpoints
export const getDeviceMaintenances = (deviceId) => api.get(`/devices/${deviceId}/maintenances`);
export const getDevicePeriodicControls = (deviceId) => api.get(`/devices/${deviceId}/periodic-controls`);

// QR Code
export const getDeviceQR = (id) => api.get(`/devices/${id}/qr`);
export const getBulkQR = (deviceIds) => api.post('/devices/bulk-qr', { deviceIds });
export const downloadAllQRCodes = (params) => api.get('/devices/qr/download-all', { params, responseType: 'blob' });
export const downloadSelectedQRCodes = (data) => api.post('/devices/qr/download-all', data, { responseType: 'blob' });

// NFC
export const getDeviceByNfc = (nfcTagId) => api.get(`/devices/nfc/${encodeURIComponent(nfcTagId)}`);
export const updateDeviceNfc = (id, nfcTagId) => api.put(`/devices/${id}/nfc`, { nfcTagId });

// Checklists
export const getChecklists = () => api.get('/checklists');
export const getChecklistsByCategory = (categoryId) => api.get(`/checklists/category/${categoryId}`);
export const createChecklist = (data) => api.post('/checklists', data);
export const updateChecklist = (id, data) => api.put(`/checklists/${id}`, data);
export const deleteChecklist = (id) => api.delete(`/checklists/${id}`);

// Spare Parts
export const getSpareParts = (params) => api.get('/spare-parts', { params });
export const getSparePart = (id) => api.get(`/spare-parts/${id}`);
export const createSparePart = (data) => api.post('/spare-parts', data);
export const updateSparePart = (id, data) => api.put(`/spare-parts/${id}`, data);
export const deleteSparePart = (id) => api.delete(`/spare-parts/${id}`);
export const getSparePartStats = () => api.get('/spare-parts/stats');
export const getLowStockSpareParts = () => api.get('/spare-parts/low-stock');
export const getSparePartMovements = (id) => api.get(`/spare-parts/${id}/movements`);
export const stockIn = (id, data) => api.post(`/spare-parts/${id}/stock-in`, data);
export const stockOut = (id, data) => api.post(`/spare-parts/${id}/stock-out`, data);
export const stockAdjust = (id, data) => api.post(`/spare-parts/${id}/adjust`, data);

// Reports - Excel/PDF Export
export const exportDevicesExcel = () => api.get('/reports/devices/excel', { responseType: 'blob' });
export const exportMaintenancesExcel = (params) => api.get('/reports/maintenances/excel', { params, responseType: 'blob' });
export const exportFaultReportsExcel = (params) => api.get('/reports/fault-reports/excel', { params, responseType: 'blob' });
export const exportSparePartsExcel = () => api.get('/reports/spare-parts/excel', { responseType: 'blob' });
export const exportDevicePDF = (id) => api.get(`/reports/devices/${id}/pdf`, { responseType: 'blob' });
export const exportSummaryPDF = (params) => api.get('/reports/summary/pdf', { params, responseType: 'blob' });
export const exportDeviceListPDF = (params) => api.get('/reports/devices/list/pdf', { params, responseType: 'blob' });

// Suppliers
export const getSuppliers = (params) => api.get('/suppliers', { params });
export const getSupplier = (id) => api.get(`/suppliers/${id}`);
export const createSupplier = (data) => api.post('/suppliers', data);
export const updateSupplier = (id, data) => api.put(`/suppliers/${id}`, data);
export const deleteSupplier = (id) => api.delete(`/suppliers/${id}`);
export const getSupplierStats = () => api.get('/suppliers/stats');

// Purchase Requests
export const getPurchaseRequests = (params) => api.get('/purchase-requests', { params });
export const getPurchaseRequest = (id) => api.get(`/purchase-requests/${id}`);
export const createPurchaseRequest = (data) => api.post('/purchase-requests', data);
export const updatePurchaseRequest = (id, data) => api.put(`/purchase-requests/${id}`, data);
export const approvePurchaseRequest = (id) => api.put(`/purchase-requests/${id}/approve`);
export const rejectPurchaseRequest = (id, data) => api.put(`/purchase-requests/${id}/reject`, data);
export const cancelPurchaseRequest = (id) => api.put(`/purchase-requests/${id}/cancel`);
export const deletePurchaseRequest = (id) => api.delete(`/purchase-requests/${id}`);
export const getPurchaseRequestStats = () => api.get('/purchase-requests/stats');
export const getLowStockSuggestions = () => api.get('/purchase-requests/low-stock-suggestions');

// Purchase Orders
export const getPurchaseOrders = (params) => api.get('/purchase-orders', { params });
export const getPurchaseOrder = (id) => api.get(`/purchase-orders/${id}`);
export const createPurchaseOrder = (data) => api.post('/purchase-orders', data);
export const updatePurchaseOrder = (id, data) => api.put(`/purchase-orders/${id}`, data);
export const updatePurchaseOrderStatus = (id, data) => api.put(`/purchase-orders/${id}/status`, data);
export const receivePurchaseOrder = (id, data) => api.put(`/purchase-orders/${id}/receive`, data);
export const addPurchaseOrderItem = (id, data) => api.post(`/purchase-orders/${id}/items`, data);
export const removePurchaseOrderItem = (orderId, itemId) => api.delete(`/purchase-orders/${orderId}/items/${itemId}`);
export const deletePurchaseOrder = (id) => api.delete(`/purchase-orders/${id}`);
export const getPurchaseOrderStats = () => api.get('/purchase-orders/stats');

// Calibration (Doğrulama ve Kalibrasyon)
export const getCalibrationDevices = (params) => api.get('/calibration', { params });
export const getCalibrationDevice = (id) => api.get(`/calibration/${id}`);
export const createCalibrationDevice = (data) => api.post('/calibration', data);
export const updateCalibrationDevice = (id, data) => api.put(`/calibration/${id}`, data);
export const deleteCalibrationDevice = (id) => api.delete(`/calibration/${id}`);
export const getCalibrationStats = () => api.get('/calibration/stats');
export const getExpiringCalibrations = (days) => api.get('/calibration/expiring', { params: { days } });
export const getCalibrationRecords = (deviceId) => api.get(`/calibration/${deviceId}/records`);
export const addCalibrationRecord = (deviceId, formData) => api.post(`/calibration/${deviceId}/records`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteCalibrationRecord = (deviceId, recordId) => api.delete(`/calibration/${deviceId}/records/${recordId}`);
export const downloadCalibrationReport = (deviceId, recordId) => api.get(`/calibration/${deviceId}/records/${recordId}/download`, { responseType: 'blob' });

// Cranes (Vinçler)
export const getCranes = (params) => api.get('/cranes', { params });
export const getCrane = (id) => api.get(`/cranes/${id}`);
export const getCraneLocations = () => api.get('/cranes/locations');

// Caddies (Kediler)
export const getCaddies = (params) => api.get('/caddies', { params });
export const transferCaddy = (caddyId, data) => api.post(`/caddies/${caddyId}/transfer`, data);
export const getCaddyTransferHistory = (caddyId) => api.get(`/caddies/${caddyId}/transfer-history`);
export const exportCaddiesPdf = (params) => api.get('/caddies/export/pdf', { params, responseType: 'blob' });

export default api;
